import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Alert,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import { categorysListUtils } from "../../utils/categorys-exercises"

import Loader from 'react-loader-advanced';

import '../../statics/css/treinos-list.css'
import '../../statics/css/util.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { sendGifFileStorage } from '../../dao-firebase/daofirebase';
import { registerExercise, updateExercise, deleteExercise } from '../../dao-firebase/exercise-firebase';
import { getAllSections, updateSectionFirebase } from '../../dao-firebase/section-daofirebae';
import TabsExercises from './tabs-exercises';

import TableExercises from './table-exercises';

class ExercisesList extends Component {

  constructor(props) {
    super(props);

    this.state = {

      //new exercise
      form_category_exercise: '',
      form_category_key: '',
      form_name_exercise: '',
      form_description_exercise: '',
      form_category_exercise: '',
      form_url_gif_exercise: '',
      form_uid_exercise: '',
      editingExercise: false,

      showModalRegisterExercise: false,
      showModalRegisterTraining: false,

      gifToSave: undefined,

      //search
      search_table_exercises: '',

      messageAll: '',
      messageNewExercise: '',

      showModalConfirmRemoveExercise: false,
      loadRemoveExercise: false,
    };

  }

  componentDidMount() {

  }

  componentWillMount() {

  }

  confirmRemoveExercise(exercise) {

    this.setState({
      exerciseToRemove: exercise,
      showModalConfirmRemoveExercise: true,
    })

  }

  removeRecursiveExerciseFromSection(sections, index, exercise) {

    let exercisesSectionToChange = sections[index].data.exercises;
    let exerciseToRemove = undefined;
    for (let i = 0; i < exercisesSectionToChange.length; i++) {
      if (exercisesSectionToChange[i].id == exercise.id) {
        exerciseToRemove = exercisesSectionToChange[i];
        break;
      }
    }

    if (exerciseToRemove) {

      //criando novo vetor agora sem o exercício que será removido
      let newExercisesSection = [];
      for (let j = 0; j < exercisesSectionToChange.length; j++) {

        //verifica-se se é o exercício a ser removido, e não o adicionamos a nova lista
        if (exercisesSectionToChange[j].id != exercise.id) {

          //caso a posicao seja superior, corrige-se com -1
          console.log(exercisesSectionToChange[j])
          console.log(exerciseToRemove)
          if (exercisesSectionToChange[j].data.infos.position_in_section > exerciseToRemove.data.infos.position_in_section) {
            exercisesSectionToChange[j].data.infos.position_in_section = exercisesSectionToChange[j].data.infos.position_in_section - 1;
          }
          newExercisesSection.push(exercisesSectionToChange[j])
        }
      }

      //atribuindo novo vetor a secao
      sections[index].exercises = newExercisesSection;

      updateSectionFirebase(JSON.parse(localStorage.getItem("USER")).uid, sections[index].id, sections[index], (response, success) => {

        if (success) {
          if (index + 1 == sections.length) {
            this.deleteExerciseFinal(exercise);
          } else {
            this.removeRecursiveExerciseFromSection(sections, index + 1, exercise);
          }

        } else {

          this.setState({

            messageAll: 'Não foi possível remover o exercício da seção: ' + sections[index].id,
            messageAllStatus: 'success',
            loadRemoveExercise: false,
            showModalConfirmRemoveExercise: false,
          })

          setTimeout(() => {

            if (this.state.messageAll == 'Não foi possível remover o exercício da seção: ' + sections[index].id) {
              this.setState({
                messageAll: '',
              });
            }

          }, 5000);

          window.scrollTo(0, 0);
        }

      })
    } else {
      if (index + 1 == sections.length) {
        this.deleteExerciseFinal(exercise);
      } else {
        this.removeRecursiveExerciseFromSection(sections, index + 1, exercise);
      }
    }

  }

  removeExercise(exercise) {

    this.setState({
      loadRemoveExercise: true,
    })

    if (exercise) {

      getAllSections(JSON.parse(localStorage.getItem("USER")).uid, (response, success) => {

        if (success) {

          this.removeRecursiveExerciseFromSection(response, 0, exercise);

        } else {
          this.setState({

            messageAll: 'Não foi possível remover o exercício',
            messageAllStatus: 'success',
            loadRemoveExercise: false,
            showModalConfirmRemoveExercise: false,
          })

          setTimeout(() => {

            if (this.state.messageAll == 'Não foi possível remover o exercício') {
              this.setState({
                messageAll: '',
              });
            }

          }, 5000);

          window.scrollTo(0, 0);
        }

      })


    }

  }

  deleteExerciseFinal(exercise) {

    deleteExercise(exercise, (success) => {

      if (success) {
        this.setState({

          messageAll: 'Exercício removido com sucesso!',
          messageAllStatus: 'success',
          loadRemoveExercise: false,
          showModalConfirmRemoveExercise: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == 'Exercício removido com sucesso!') {
            this.setState({
              messageAll: '',
            });
          }

        }, 5000);

        window.scrollTo(0, 0);

      } else {
        this.setState({

          messageAll: 'Falha ao remover o exercício!',
          messageAllStatus: 'error',
          load: false,
          showModalConfirmRemoveExercise: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == 'Falha ao remover o exercício!') {
            this.setState({
              messageAll: '',
            });
          }

        }, 5000);

        window.scrollTo(0, 0);
      }

    })
  }

  registerExercise(exercise) {

    //Caso haja um exercício popula-se o formulário com os respectivos valores
    if (exercise) {

      //Obtendo o nome da categoria. MELHORAR ISSO!!!!
      //Possível solução, transformar a categorysListUtils em um mapa que se acessa pela key
      let thatCategory = '';
      for (let i = 0; i < categorysListUtils.length; i++) {
        console.log("COMPARE: " + categorysListUtils[i].key + "==" + exercise.data.category);
        if (categorysListUtils[i].key == exercise.data.category) {
          thatCategory = categorysListUtils[i].name;
          break;
        }
      }
      this.setState({
        form_uid_exercise: exercise.id,
        form_name_exercise: exercise.data.name,
        form_description_exercise: exercise.data.description,
        messageAll: '',
        messageNewExercise: '',
        messageNewExerciseStatus: '',
        gifToSave: undefined,
        form_url_gif_exercise: exercise.data.url_gif,
        form_category_exercise: thatCategory,
        showModalRegisterExercise: true,
        editingExercise: true,
      })
    } else {

      //localStorage.setItem("USER", JSON.stringify(response))
      let lastCategory = categorysListUtils[0].name;

      console.log("INICIANDO NOVO EXERCICIO: " + localStorage.getItem("LAST_CATEGORY_SELECTED"))
      if (localStorage.getItem("LAST_CATEGORY_SELECTED") != undefined) {

        let toCompare = localStorage.getItem("LAST_CATEGORY_SELECTED");
        for (let i = 0; i < categorysListUtils.length; i++) {
          console.log("COMPARE: " + categorysListUtils[i].key + "==" + toCompare);
          if (categorysListUtils[i].key == toCompare) {
            lastCategory = categorysListUtils[i].name;
            break;
          }
        }

      }

      this.setState({
        form_name_exercise: '',
        form_description_exercise: '',
        form_url_gif_exercise: '',
        messageAll: '',
        messageNewExercise: '',
        messageNewExerciseStatus: '',
        gifToSave: undefined,
        //Colocando a última categoria selecinada como a default
        form_category_exercise: lastCategory,
        showModalRegisterExercise: true,
        editingExercise: false,
      })
    }
  }

  handleCloseRegisterExercise() {
    this.setState({
      showModalRegisterExercise: false,
    })
  }

  registerTraining() {
    // this.setState({

    //   showModalRegisterTraining: true,
    // })

    this.props.history.push("/treino/montar");
  }

  handleCloseRegisterTraining() {
    this.setState({
      showModalRegisterTraining: false,
    })
  }

  onInputChange(target) {

    //console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onChangeCategoryExercise(event) {
    console.log(event.target.value)
    this.setState({
      form_category_exercise: event.target.value
    })
  }

  saveNewExercise(editExercise) {

    this.setState({
      load: true,
      messageAll: '',
      messageNewExercise: '',
      messageNewExerciseStatus: '',
    })

    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;

    if (this.state.form_name_exercise != '') {

      let thatCategoryKey = '';
      for (let i = 0; i < categorysListUtils.length; i++) {
        //console.log("COMPARE: " + categorysListUtils[i].name + "==" + this.state.form_category_exercise);
        if (categorysListUtils[i].name == this.state.form_category_exercise) {
          thatCategoryKey = categorysListUtils[i].key;
          break;
        }
      }

      //Montando usuário
      let exercise = {
        name: this.state.form_name_exercise,
        description: this.state.form_description_exercise,
        category: thatCategoryKey,
      }

      localStorage.setItem("LAST_CATEGORY_SELECTED", thatCategoryKey);
      console.log("CATEGORIA NA CACHE" + localStorage.getItem("LAST_CATEGORY_SELECTED"));

      //Existe um exercício já existente sendo apenas editado
      if (editExercise) {

        //Verifica se o gif foi alterado
        //Caso exista alteração no gif, 'gifToSave' é diferente de undefined
        if (this.state.gifToSave) {
          sendGifFileStorage(uidProfessor, this.state.gifToSave, this.state.form_uid_exercise, (response, success) => {
            if (success) {
              //Atualizar o exercício
              //Em caso de sucesso a response é a url do gif salva no storage
              exercise.url_gif = response;
              updateExercise(uidProfessor, this.state.form_uid_exercise, exercise, (response, success) => {

                if (success) {
                  this.setState({
                    messageAll: "Exercício atualizado com sucesso!",
                    messageAllStatus: "success",

                    //Limpando formulário
                    form_uid_exercise: '',
                    form_name_exercise: '',
                    form_description_exercise: '',
                    form_url_gif_exercise: '',
                    gifToSave: undefined,
                    //form_category_exercise: categorysListUtils[0].name,
                    showModalRegisterExercise: false,
                    editingExercise: false,

                    load: false,
                  })

                  //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
                  window.scrollTo(0, 0);

                } else {
                  this.setState({
                    messageNewExercise: "Falha ao atualizar o exercício: " + response.message,
                    load: false,
                  })
                }
              })

            } else {
              this.setState({
                messageNewExercise: "Falha ao atualizar Gif: " + response.message,
                load: false,
              })
            }
          })
        } else {

          //Não houve alteração do gif, atualiza-se apenas as informações adicionais
          updateExercise(uidProfessor, this.state.form_uid_exercise, exercise, (response, success) => {

            if (success) {
              this.setState({
                messageAll: "Exercício atualizado com sucesso!",
                messageAllStatus: "success",

                //Limpando formulário
                form_uid_exercise: '',
                form_name_exercise: '',
                form_description_exercise: '',
                form_url_gif_exercise: '',
                gifToSave: undefined,
                //form_category_exercise: categorysListUtils[0].name,
                showModalRegisterExercise: false,
                editingExercise: false,

                load: false,
              })

              //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
              window.scrollTo(0, 0);
            } else {
              this.setState({
                messageNewExercise: "Falha ao atualizar o exercício: " + response.message,
                load: false,
              })
            }
          })
        }

      } else {

        //Novo exercício sendo registrado
        registerExercise(exercise, (response, success) => {
          if (success) {
            //Salvar gif caso exista
            //Quando a resposta é sucesso ela vem em formato de doc
            let uidExercise = response.id;
            if (this.state.gifToSave) {
              sendGifFileStorage(uidProfessor, this.state.gifToSave, uidExercise, (response, success) => {
                if (success) {
                  //Atualizar a url do vídeo do exercício
                  //Em caso de sucesso a response é a url do gif salva no storage
                  updateExercise(uidProfessor, uidExercise, { url_gif: response }, (response, success) => {

                    if (success) {
                      this.setState({
                        messageAll: "Exercício salvo com sucesso!",
                        messageAllStatus: "success",

                        //Limpando formulário
                        form_uid_exercise: '',
                        form_name_exercise: '',
                        form_description_exercise: '',
                        form_url_gif_exercise: '',
                        gifToSave: undefined,
                        //form_category_exercise: categorysListUtils[0].name,
                        showModalRegisterExercise: false,
                        editingExercise: false,

                        load: false,
                      })

                      //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
                      window.scrollTo(0, 0);

                    } else {
                      this.setState({
                        messageNewExercise: "Falha ao atualizar link do gif no exercício: " + response.message,
                        load: false,
                      })
                    }
                  })

                } else {
                  this.setState({
                    messageNewExercise: "Falha ao salvar Gif: " + response.message,
                    load: false,
                  })
                }
              })
            } else {
              this.setState({
                messageAll: "Exercício salvo com sucesso!",
                messageAllStatus: "success",

                //Limpando formulário
                form_uid_exercise: '',
                form_name_exercise: '',
                form_description_exercise: '',
                form_url_gif_exercise: '',
                gifToSave: undefined,
                //form_category_exercise: categorysListUtils[0].name,
                showModalRegisterExercise: false,
                editingExercise: false,

                load: false,
              })
            }
          } else {
            this.setState({
              messageNewExercise: response.message,
              load: false,
            });
          }
        })
      }


    } else {
      this.setState({
        messageNewExercise: "Insira um nome para o exercício",
        load: false,
      });
    }
  }

  renderOptionsCategorys() {
    return _.map(categorysListUtils, (category) => {
      return (

        // <option value={category.key}>{category.name}</option>

        <If test={true}>
          <If test={this.state.form_category_exercise && this.state.form_category_exercise == category.name}>
            <option value={category.name} selected>{category.name}</option>
          </If>
          <If test={this.state.form_category_exercise != category.name}>
            <option value={category.name}>{category.name}</option>
          </If>
        </If>
      )
    })
  }

  uploadGifExercise() {

    let node = ReactDOM.findDOMNode(this.refs.inputGifExercise);
    if (node && node.focus instanceof Function) {
      node.click();
    }

  }

  handleGifUpload(event) {

    const file = event.target.files[0]

    if (file) {
      this.setState({
        gifToSave: file,
      })
    }

  }

  handleCloseConfirmRemoveExercise() {
    this.setState({
      showModalConfirmRemoveExercise: false,
    })
  }

  render() {

    return (
      <div className="treinos-list-page">

        {this.state.messageAll != '' ?
          <Alert bsStyle={!this.state.messageAllStatus || this.state.messageAllStatus == '' ? 'warning' : this.state.messageAllStatus}>
            <p>{this.state.messageAll}</p>
          </Alert>
          : null}

        <Grid>
          <Row className="infos-body-profile">
            <Col md={12} className="no-p-left no-p-right">
              <Jumbotron>
                <h2>Novo Exercício</h2>
                <p>Informe o nome, a descrição e insira um vídeo para criar um novo exercício</p>
                <p>
                  <Button bsStyle="primary" onClick={() => this.registerExercise(undefined)}>Cadastrar exercício</Button>
                </p>
              </Jumbotron>
            </Col>
            {/* <Col md={6} className="no-p-right">
              <Jumbotron>
                <h2>Novo Treino</h2>
                <p>Selecione dentre os vários exercícios cadastrados e monte o treino da forma que quiser</p>
                <p>
                  <Button bsStyle="success" onClick={() => this.registerTraining()}>Cadastrar treino</Button>
                </p>
              </Jumbotron>
            </Col> */}
          </Row>
        </Grid>

        <Grid>
          <Row className="flex-row">
            <Col xs={9} md={9} className="no-p-left no-p-right text-left">
              <h2 className="label-table">Exercícios</h2>
            </Col>
            <Col xs={3} md={3} className="no-p-left no-p-right text-left">
              <FormControl
                name="search_table_exercises"
                type="text"
                value={this.state.search_table_exercises}
                placeholder="Pesquisar exercício"
                onChange={(event) => this.onInputChange(event.target)} />
            </Col>
          </Row>
        </Grid>

        <TabsExercises handleEditExercise={(exercise) => this.registerExercise(exercise)} handleRemoveExercise={(exercise) => this.confirmRemoveExercise(exercise)} search={this.state.search_table_exercises} />

        <Modal show={this.state.showModalRegisterExercise}
          bsSize="large">
          <Loader show={this.state.load} message={<div className="loader"></div>}
            backgroundStyle={{ backgroundColor: 'none' }}
            foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
            <Modal.Header>
              <Modal.Title>Cadastrar Exercício</Modal.Title>
            </Modal.Header>

            <Modal.Body className="modal-body-new-exercise">

              {this.state.messageNewExercise != '' ?
                <Alert bsStyle={!this.state.messageNewExerciseStatus || this.state.messageNewExerciseStatus == '' ? 'warning' : this.state.messageNewExerciseStatus}>
                  <p>{this.state.messageNewExercise}</p>
                </Alert>
                : null}

              <Grid>
                <Row className="flex-row">
                  <Col xs={4} md={4} className="no-p-left no-p-right">

                    <div className="background-video-new-exercise" onClick={() => this.uploadGifExercise()}>
                      <If test={this.state.gifToSave}>

                        <div className="center-cropped2-input">
                          <Image src={this.state.gifToSave ? URL.createObjectURL(this.state.gifToSave) : ""} />
                        </div>
                        <div className="overlay-img" />

                        <p className="label-action-new-video-edit">Editar</p>
                      </If>
                      <If test={!this.state.gifToSave && this.state.form_url_gif_exercise}>

                        <div className="center-cropped2-input">
                          <Image src={this.state.form_url_gif_exercise ? this.state.form_url_gif_exercise : ""} />
                        </div>
                        <div className="overlay-img" />

                        <p className="label-action-new-video-edit">Editar</p>
                      </If>
                      <If test={!this.state.gifToSave && !this.state.form_url_gif_exercise}>
                        <Image src={videoPlayerIcon} responsive className="img-new-video" />
                        <p className="label-action-new-video">Adicionar</p>
                      </If>
                      <FormControl
                        ref="inputGifExercise"
                        className="input-file-body input-file-gone"
                        type="file"
                        onChange={(e) => this.handleGifUpload(e)}
                      />
                    </div>
                  </Col>
                  <Col xs={8} md={8}>

                    <FormGroup controlId="formControlsSelectCategoryExercise">
                      <ControlLabel>Grupo muscular</ControlLabel>
                      <FormControl componentClass="select" placeholder="Selecione" onChange={(event) => this.onChangeCategoryExercise(event)}>
                        {this.renderOptionsCategorys()}

                      </FormControl>
                    </FormGroup>

                    <FormGroup controlId="formControlsNameExercise">
                      <ControlLabel>Nome do exercício</ControlLabel>
                      <FormControl
                        name="form_name_exercise"
                        type="text"
                        value={this.state.form_name_exercise}
                        placeholder="Insira o nome"
                        onChange={(event) => this.onInputChange(event.target)} />
                    </FormGroup>

                    <FormGroup controlId="formControlsDescriptionExercise">
                      <ControlLabel>Descrição do exercício</ControlLabel>
                      <FormControl
                        rows="5"
                        componentClass="textarea"
                        name="form_description_exercise"
                        type="text"
                        className="textarea-fixed"
                        value={this.state.form_description_exercise}
                        placeholder="Insira a descrição"
                        onChange={(event) => this.onInputChange(event.target)} />
                    </FormGroup>
                  </Col>
                </Row>
              </Grid>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => this.handleCloseRegisterExercise()}>Fechar</Button>
              <If test={!this.state.editingExercise}>
                <Button bsStyle="primary" onClick={() => this.saveNewExercise(false)}>Salvar</Button>
              </If>
              <If test={this.state.editingExercise}>
                <Button bsStyle="primary" onClick={() => this.saveNewExercise(true)}>Atualizar</Button>
              </If>
            </Modal.Footer>

          </Loader>
        </Modal>

        <Modal show={this.state.showModalConfirmRemoveExercise}
          bsSize="small">
          <Loader show={this.state.loadRemoveExercise} message={<div className="loader"></div>}
            backgroundStyle={{ backgroundColor: 'none' }}
            foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
            <Modal.Header>
              <Modal.Title>Remover exercício</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              <h4>Deseja realmente remover o exercício:</h4>
              <h2><b>{this.state.exerciseToRemove ? this.state.exerciseToRemove.data.name : null}</b></h2>

            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => this.handleCloseConfirmRemoveExercise()}>Fechar</Button>
              <Button bsStyle="danger" onClick={() => this.removeExercise(this.state.exerciseToRemove)}>Excluir</Button>

            </Modal.Footer>

          </Loader>
        </Modal>

      </div >
    );
  }
}

export default ExercisesList;



// WEBPACK FOOTER //
// src/components/treinos/exercises-list.js